export default __webpack_public_path__ + "0533b8ce39605d6cb394e4e34d717b6e.svg";